import React, { useState, useEffect, useContext } from "react";
import Web3Modal from "web3modal";
// import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletConnect from "@walletconnect/web3-provider";
import "./App.css";
import { WalletContext } from "./components/context";
import SwapContent from "./components/SwapContent";
import DialogModal from "./components/Dialog/DialogModal";
import ReactLoading from "react-loading";
import useWindowDimensions from "./hooks/useWindowDimensions";
import { walletManage } from "./web3";
import { get } from "lodash";
import { Colors } from "./utils";
import Button from "./components/Button";

function App() {
  const { onConnectWalletClick, loading, hideAppLoading } =
    useContext(WalletContext);

  const initWeb3Modal = () => {
    const expectedChainID = +process.env.REACT_APP_EXPECTED_CHAIN_ID;
    const providerOptions = {
      walletconnect: {
        package: WalletConnect, // required
        options: {
          rpc: {
            56: "https://bsc-dataseed1.binance.org",
            97: "https://data-seed-prebsc-1-s1.binance.org:8545",
          },
          infuraId:
            "wss://mainnet.infura.io/ws/v3/9d62b9e3322b4e7798d449fcaa1666e2",
          bridge: "https://dev-bridge.shopnext.io",
          chainId: expectedChainID,
          network: "binance",
          qrcode: true,
          qrcodeModalOptions: {
            mobileLinks: ["metamask", "trust"],
          },
        },
      },
    };
    walletManage.modal = new Web3Modal({
      network: "mainnet", // optional
      cacheProvider: true,
      providerOptions, // required
      disableInjectedProvider: false,
    });
  };

  useEffect(() => {
    initWeb3Modal();
    if (walletManage.modal.cachedProvider) {
      onConnectWalletClick();
    }
    // if (
    //   window &&
    //   window.localStorage &&
    //   window.localStorage.getItem("walletconnect")
    // ) {
    //   onConnectWalletClick();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AppContent />
      <DialogModal />
      {get(loading, "show") === true && (
        <div className="loading-container">
          <div className="content-loading">
            {get(loading, "showCloseButton") === true && (
              <button
                className="close-image close-image d-block mr-0 ml-auto"
                onClick={() => {
                  hideAppLoading();
                }}
              />
            )}
            <span
              className="text-5"
              style={{
                display: "flex",
                textAlign: "center",
                fontWeight: 500,
                color: "#000",
                marginBottom: 40,
                marginTop: 28,
              }}
            >
              {get(loading, "message")}
            </span>
            {get(loading, "showSpinner") === true && (
              <ReactLoading
                className="app-loading"
                type="spokes"
                color={Colors.main}
              />
            )}
            {get(loading, "buttonText") && (
              <Button
                type="secondary"
                title={get(loading, "buttonText")}
                onClick={get(loading, "buttonClick")}
              />
            )}
          </div>
        </div>
      )}
      {/* <SwapContent />
     {get(wallet, 'connected') === true ? <ConnectedView /> :  <DisconnectedView /> }
          <Row xs={6} md={8}>
          </Row>
          {get(wallet, 'connected') === true &&  <Row className="App-row">
            {<span className="App-event">Last Event</span>}
            {<span className="App-event">{lastEvent}</span>}
          </Row>} */}
      {/* <div className="App">
        <div className="App-logo-view">
          <img
            className="App-logo-shopnext"
            alt="Porto"
            src="https://stc.shopnext.io/web/custom/shopnext/img/logo_ShopNEXT.png"
          ></img>
        </div>
        <div className="ActionView">
        {get(wallet, 'connected') === true ? <ConnectedView /> :  <DisconnectedView /> }
          <Row xs={6} md={8}>
          </Row>
          {get(wallet, 'connected') === true &&  <Row className="App-row">
            {<span className="App-event">Last Event</span>}
            {<span className="App-event">{lastEvent}</span>}
          </Row>}
        </div>
      </div> */}
    </>
  );
}

const AppContent = () => {
  const { width } = useWindowDimensions();
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (width > 991 && showMenu === true) {
      setShowMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);


  const onOldNextAddressClick = () => {
    window.open('https://bscscan.com/token/0x9809e877192B510D767a94ba39a79429219a5afB')
  }

  return (
    <div>
      {/* Basic */}
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <title>ShopNEXT | A Web3 Loyalty Platform | Shop To Earn Crypto</title>
      <meta
        name="keywords"
        content="web3 loyalty platform, shop to earn, crypto cashback, crypto onboarding, crypto adoption, crypto rewards, token rewards"
      />
      <meta
        name="description"
        content="ShopNEXT is a Web3 Loyalty Platform powered by VISA and BNB chain. We utilize card payment, NFT and gamification to invent the Shop-To-Earn model. ShopNEXT allows users to earn token rewards from daily shopping while helping merchants grow their businesses."
      />
      <meta name="author" content="ShopNEXT" />
      {/* Favicon */}
      <link
        rel="shortcut icon"
        href="https://stc.shopnext.io/web/custom/shopnext/img/favicon.png"
        type="image/x-icon"
      />
      <link
        rel="apple-touch-icon"
        href="https://stc.shopnext.io/web/custom/shopnext/img/apple-touch-icon.png"
      />
      <meta name="apple-itunes-app-custom" content="app-id=1595137327" />
      <meta name="google-play-app" content="app-id=com.shopnext.shopnext" />
      {/* Mobile Metas */}
      {/*<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, shrink-to-fit=no">*/}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      />
      <meta
        property="og:title"
        content="ShopNEXT | A Web3 Loyalty Platform | Shop To Earn Crypto"
      />
      <meta
        property="og:image"
        content="https://stc.shopnext.io/web/custom/shopnext/img/social-thumbnail-2.png"
      />
      {/* Web Fonts  */}
      <link
        id="googleFonts"
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700,800%7CShadows+Into+Light&display=swap"
        rel="stylesheet"
        type="text/css"
      />
      {/* Vendor CSS */}
      <link
        rel="stylesheet"
        href="https://stc.shopnext.io/web/vendor/bootstrap/css/bootstrap.min.css"
      />
      <link
        rel="stylesheet"
        href="https://stc.shopnext.io/web/vendor/fontawesome-free/css/all.min.css"
      />
      <link
        rel="stylesheet"
        href="https://stc.shopnext.io/web/vendor/simple-line-icons/css/simple-line-icons.min.css"
      />
      {/* Theme CSS */}
      <link rel="stylesheet" href="https://stc.shopnext.io/web/css/theme.css" />
      <link
        rel="stylesheet"
        href="https://stc.shopnext.io/web/css/theme-elements.css"
      />
      {/* Skin CSS */}
      <link
        id="skinCSS"
        rel="stylesheet"
        href="https://stc.shopnext.io/web/css/skins/default.css"
      />
      {/* Theme Custom CSS */}
      <link
        rel="stylesheet"
        href="https://stc.shopnext.io/web/css/custom.css"
      />
      <link
        rel="stylesheet"
        href="https://stc.shopiness.vn/web/web.v2/css/jquery.smartbanner.css"
      />
      {/* Head Libs */}
      {/* Google Tag Manager */}
      {/* End Google Tag Manager */}
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n            body{font-family:Roboto,sans-serif}.header-logo img{width:auto}.color-red-shop{color:#5865ef}.color-red-shop-bg{background-color:#5865ef;border-color:#5865ef}.process .process-step-circle{border-color:#5865ef}.process .process-step:hover .process-step-circle{background-color:#5865ef}.process .process-step:before{background-color:#5865ef}.process-connecting-line .connecting-line{background:#5865ef}#footer{background:#5865ef;border-top:4px solid #5865ef}#footer .footer-copyright{background:#5865ef}#footer a:not(.btn):not(.no-footer-css){color:#fffF}.partner-logo{width:100%;height:auto;margin:0 auto}.img-thumbnail .zoom,.thumb-info .thumb-info-action-icon,.thumb-info .thumb-info-type,.thumb-info-ribbon,.thumb-info-social-icons a,.thumbnail .zoom{background-color:#5865ef}.separator-block{margin:0 auto;height:40px;padding:0;width:150px;border-top:3px solid #5865ef}body p{color:#212529}#header .header-nav.header-nav-links nav>ul li:hover>a{color:#49dee2}#header .header-nav.header-nav-links nav>ul:not(:hover)>li>a.active{color:#49dee2}#header .header-btn-collapse-nav{background:#49dee2}.owl-carousel .owl-dots .owl-dot.active span,.owl-carousel .owl-dots .owl-dot:hover span{background-color:#5865ef}.process.process-shapes .process-step-circle .process-step-circle-content,.process.process-shapes .process-step-circle:after,.process.process-shapes .process-step-circle:before{background-color:#5865ef}@media (max-width:991px){#header .header-nav-main.header-nav-main-mobile-dark:before{background-color:#5865ef}#header .header-nav-main.header-nav-main-mobile-dark nav>ul li{border-bottom:1px solid #fff}#header .header-nav-main.header-nav-main-mobile-dark nav>ul>li>a{color:#fff}#header .header-nav-main.header-nav-main-mobile-dark nav>ul li a:active,#header .header-nav-main.header-nav-main-mobile-dark nav>ul li a:focus,#header .header-nav-main.header-nav-main-mobile-dark nav>ul li a:hover{background-color:#5865ef}#header .header-nav-main.header-nav-main-mobile-dark nav>ul>li>a.active:focus,#header .header-nav-main.header-nav-main-mobile-dark nav>ul>li>a.active:hover{background:#5865ef}#header .header-nav-main.header-nav-main-mobile-dark nav>ul>li>a.active{background:#5865ef;color:#49dee2}.process-connecting-line .connecting-line{display:none}}@media (min-width:992px){.footer-contact-info{text-align:right}.partner-logo{width:70%}}tbody,td,tfoot,th,thead,tr{border-color:#5865ef !important;padding-top:1.2em !important;padding-bottom:1.2em !important}.table td:nth-child(even){text-align:right;word-break: break-all}.grecaptcha-badge{visibility:hidden}\n            .btn-download img{\n                max-height: 45px; \n                margin-top: 10px\n            }\n            .color-white-shop-bg{background-color:#fff;border-color:#fff;color: #5865ef}\n            .color-white-shop-bg:hover, .color-white-shop-bg:visited{\n                color: #5865ef\n            }\n            \n            .btn-audit img{\n                max-height: 55px; \n                margin-top: 0px\n            }\n            .clip-star {\n                background: gold;\n                -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n                clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n                display: inline-block;\n                height: 11px;\n                width: 11px;\n              }\n              iframe {\n                  border:3px solid #FFFFFF;\n                    border-radius: 20px ;\n                }\n        ",
        }}
      />
      {/* Google Tag Manager (noscript) */}
      <noscript>
        &lt;iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W6KHZ9R"
        height="0" width="0"
        style="display:none;visibility:hidden"&gt;&lt;/iframe&gt;
      </noscript>
      {/* End Google Tag Manager (noscript) */}
      <div className="body">
        <header
          id="header"
          style={
            width >= 991 ? { position: "fixed", zIndex: 2 } : { zIndex: 2 }
          }
          className="header-transparent header-effect-shrink header-linear"
          // data-plugin-options="{'stickyEnabled': true, 'stickyEffect': 'shrink', 'stickyEnableOnBoxed': true, 'stickyEnableOnMobile': false, 'stickyChangeLogo': true, 'stickyStartAt': 30, 'stickyHeaderContainerHeight': 70}"
        >
          <div className="header-body border-top-0 box-shadow-none color-red-shop-bg">
            <div className="header-container container">
              <div className="header-row">
                <div className="header-column">
                  <div className="header-row">
                    <div className="header-logo">
                      <a href="https://shopnext.io">
                        <img
                          alt="Porto"
                          height={45}
                          src="https://stc.shopnext.io/web/custom/shopnext/img/logo_ShopNEXT.png"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="header-column justify-content-end">
                  <div className="header-row">
                    <div className="header-nav header-nav-links header-nav-dropdowns-dark header-nav-light-text order-2 order-lg-1">
                      <div className="header-nav-main header-nav-main-font-lg header-nav-main-font-lg-upper-2 header-nav-main-mobile-dark header-nav-main-square header-nav-main-dropdown-no-borders header-nav-main-effect-2 header-nav-main-sub-effect-1">
                        <nav className="collapse">
                          <ul className="nav nav-pills" id="mainNav">
                            <li>
                              <a
                                className="nav-link"
                                target="_blank"
                                rel="noreferrer"
                                href="https://shopnext.gitbook.io/english/"
                              >
                                Whitepaper
                              </a>
                            </li>
                            <li>
                              <a
                                className="nav-link"
                                target="_blank"
                                rel="noreferrer"
                                href="https://shopnext.gitbook.io/english/whitepaper/how-to-play"
                              >
                                How to play
                              </a>
                            </li>
                            <li>
                              <a
                                className="nav-link"
                                target="_blank"
                                rel="noreferrer"
                                href="https://shopnext.gitbook.io/english/faq"
                              >
                                FAQ
                              </a>
                            </li>
                            <li>
                              <a
                                className="nav-link"
                                target="_blank"
                                rel="noreferrer"
                                href="https://blog.shopnext.io/"
                              >
                                Blog
                              </a>
                            </li>
                            <li>
                              <a
                                className="nav-link"
                                target="_blank"
                                rel="noreferrer"
                                href="https://linktr.ee/helloshopnext"
                              >
                                Linktree
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                      <button
                        className="btn header-btn-collapse-nav"
                        data-bs-toggle="collapse"
                        data-bs-target=".header-nav-main nav"
                        onClick={() => setShowMenu(!showMenu)}
                      >
                        <i className="fas fa-bars" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showMenu === true && (
            <div className="header-nav-main header-nav-main-font-lg header-nav-main-font-lg-upper-2 header-nav-main-mobile-dark header-nav-main-square header-nav-main-dropdown-no-borders header-nav-main-effect-2 header-nav-main-sub-effect-1">
              <nav>
                <ul className="nav nav-pills" id="mainNav">
                  <li>
                    <a
                      className="nav-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://shopnext.gitbook.io/english/"
                    >
                      Whitepaper
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://shopnext.gitbook.io/english/whitepaper/how-to-play"
                    >
                      How to play
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://shopnext.gitbook.io/english/faq"
                    >
                      FAQ
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://blog.shopnext.io/"
                    >
                      Blog
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://linktr.ee/helloshopnext"
                    >
                      Support center
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </header>
        <div role="main" className="main">
          <section
            style={{
              backgroundImage: "linear-gradient(#5865ef 70%, #ffffff 0%)",
            }}
            className="section color-red-shop-bg border-0 m-0"
          >
            <div
              id="tokennomics"
              className="container mt-5 pt-5"
            >
              <div className="row mb-3 justify-content-center">
                <div
                  className="col-lg-10 text-center"
                >
                  <h1
                    style={{ color: "#fff" }}
                    className="font-weight-bold mb-4"
                  >
                    Claim NFT Airdrop
                  </h1>
                  <div
                    style={{ borderTopColor: "#fff", width: "80px" }}
                    className="spacer separator-block"
                  />
                  <p className="text-4" style={{ color: "#fff" }}>
                    If you've won an NFT card case Airdrop
                    <br />
                    Click the button below and complete the following steps to claim your NFT card case.
                  </p>
                </div>
              </div>
              <div className="row mb-5 justify-content-center">
                {/* <a style={{width: 'auto'}} data-bs-target="#defaultModal" data-bs-toggle="modal" href="javascript:void(0)" className="btn btn-danger btn-rounded hover-pink font-weight-semibold text-4 px-5 btn-py-2 text-2 color-white-shop-bg" data-appear-animation="fadeInUpShorter" data-appear-animation-delay={200}>Connect wallet to swap</a> */}
                <SwapContent />
              </div>
              <div
                className="row mb-5 justify-content-center" style={{paddingTop: "25px"}}
              >
                <div className="row" style={{paddingLeft: 0, paddingRight: 0}}>
                  <div className="col-lg-4 mb-3" style={{marginLeft: "-3px", marginRight: "-3px"}}>
                    <div
                      className="pt-4 pb-3 text-center"
                      style={{
                        margin: "1px 1px 0 0",
                        backgroundColor: "#F2F5FC",
                        borderRadius: "20px",
                      }}
                    >
                      <div className='mt-3' style={{height: "113px"}}>
                        <img
                          src="https://stc.shopnext.io/nft-card/ad/card-case.png"
                          width="181px"
                          height="auto"
                          alt=""
                        />
                      </div>
                      <div className='my-3 px-5 mb-4'>
                        <p className="px-4 text-4"
                        style={{
                          textAlign: "center",
                          letterSpacing: "0px",
                          color: "#000000",
                          opacity: 1 }}
                        >Trade your card case on Opensea</p>
                      </div>
                      <div className='my-3'>
                        <a className='btn btn-danger btn-rounded hover-pink font-weight-semibold text-4 px-5 btn-py-2 text-2 color-red-shop-bg appear-animation animated fadeInUpShorter appear-animation-visible'
                          href='https://opensea.io/collection/shopnext-nft-card'
                          target="_blank"
                          rel="noreferrer"
                        >Learn more</a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-3" style={{marginLeft: "-3px", marginRight: "-3px"}}>
                    <div
                      className="pt-4 pb-3 text-center"
                      style={{
                        margin: "1px 1px 0 0",
                        backgroundColor: "#F2F5FC",
                        borderRadius: "20px",
                      }}
                    >
                      <div className='mt-3' style={{height: "113px"}}>
                        <img
                          src="https://stc.shopnext.io/nft-card/ad/open-case.png"
                          width="181px"
                          height="auto"
                          alt=""
                        />
                      </div>
                      <div className='my-3 px-5 mb-4'>
                        <p className="px-4 text-4"
                        style={{
                          textAlign: "center",
                          letterSpacing: "0px",
                          color: "#000000",
                          opacity: 1 }}
                        >Open your card case to get an NFT card</p>
                      </div>
                      <div className='my-3'>
                        <a className='btn btn-danger btn-rounded hover-pink font-weight-semibold text-4 px-5 btn-py-2 text-2 color-red-shop-bg appear-animation animated fadeInUpShorter appear-animation-visible'
                          href='https://docs.shopnext.io/whitepaper/how-to-play/card-case-opening-mechanism'
                          target="_blank"
                          rel="noreferrer"
                        >Learn more</a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-3" style={{marginLeft: "-3px", marginRight: "-3px"}}>
                    <div
                      className="pt-4 pb-3 text-center"
                      style={{
                        margin: "1px 1px 0 0",
                        backgroundColor: "#F2F5FC",
                        borderRadius: "20px",
                      }}
                    >
                      <div className='mt-3' style={{height: "113px"}}>
                        <img
                          src="https://stc.shopnext.io/nft-card/ad/cards.png"
                          width="181px"
                          height="auto"
                          alt=""
                        />
                      </div>
                      <div className='my-3 px-5 mb-4'>
                        <p className="px-4 text-4"
                        style={{
                          textAlign: "center",
                          letterSpacing: "0px",
                          color: "#000000",
                          opacity: 1 }}
                        >Shop with NFT cards to earn more token rewards</p>
                      </div>
                      <div className='my-3'>
                        <a className='btn btn-danger btn-rounded hover-pink font-weight-semibold text-4 px-5 btn-py-2 text-2 color-red-shop-bg appear-animation animated fadeInUpShorter appear-animation-visible'
                          href='https://docs.shopnext.io/whitepaper/how-to-play'
                          target="_blank"
                          rel="noreferrer"
                        >Learn more</a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
        <footer id="footer" className="mt-0">
          <div className="footer-copyright">
            <div className="container py-2">
              <div className="row py-4">
                <div className="col-lg-7">
                  <a href="https://shopnext.io" className="logo pe-0 pe-lg-3">
                    <img
                      alt="ShopNext"
                      src="https://stc.shopnext.io/web/custom/shopnext/img/logo_ShopNEXT.png"
                      height={45}
                    />
                  </a>
                  <div>
                    <p className="text-3 mt-1" style={{ color: "#FFFF" }}>
                      © 2021, ShopNEXT LLC - All rights reserved.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3" style={{ padding: "10px 10px 20px" }}>
                  <a
                    className="btn-download"
                    style={{ marginRight: "10px" }}
                    href="https://app.shopnext.io/QZ3tgjHHo9jd6NPd9"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="https://stc.shopnext.io/web/custom/shopnext/img/v2/Appstore/iOS.png" />
                  </a>
                  <a
                    className="btn-download"
                    href="https://app.shopnext.io/8WfpvGr6Dx82YQ2k8"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="https://stc.shopnext.io/web/custom/shopnext/img/v2/Appstore/Android.png" />
                  </a>
                </div>
                <div className="col-lg-2 footer-contact-info">
                  <a
                    href="mailto:hello@shopnext.io"
                    className="logo pe-0  text-4"
                    style={{ color: "#FFFF" }}
                  >
                    <i className="fas fa-envelope" /> hello@shopnext.io
                  </a>
                  <nav id="sub-menu" className="text-5 mt-1">
                    <ul>
                      <li>
                        <a target="_blank"
                        rel="noreferrer" href="https://discord.gg/B8dj9RN6qQ">
                          <i className="fab fa-discord" />
                        </a>
                      </li>
                      <li>
                        <a
                          tabIndex={0}
                          // href="javascript:;"
                          data-bs-html="true"
                          data-bs-container="body"
                          data-bs-trigger="focus"
                          data-bs-toggle="popover"
                          data-bs-placement="top"
                          data-bs-content='<a target="_blank" rel="noreferrer" href="https://t.me/shopnext_vietnam/">Vietnam</a><br><a target="_blank"
                            rel="noreferrer"
                           href="https://t.me/shopnext_chat/">Global</a>'
                          data-bs-original-title
                          // title
                        >
                          <i className="fab fa-telegram-plane" />
                        </a>
                      </li>
                      {/*                                        <li><a target="_blank"
                      rel="noreferrer" href="https://t.me/shopnext_vietnam/"><i class="fab fa-telegram-plane"></i></a></li>*/}
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://twitter.com/helloshopnext"
                        >
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank"
                        rel="noreferrer" href="https://fb.com/hello.shopnext">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      {/*<li><a target="_blank"
                      rel="noreferrer" href="https://blog.shopnext.io/"><i class="fas fa-rss"></i></a></li>*/}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div
        className="modal fade"
        id="defaultModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="defaultModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="defaultModalLabel">
                Default Modal Title
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Curabitur pellentesque neque eget diam posuere porta. Quisque ut
                nulla at nunc <a href="#">vehicula</a> lacinia. Proin adipiscing
                porta tellus, ut feugiat nibh adipiscing sit amet. In eu justo a
                felis faucibus ornare vel id metus. Vestibulum ante ipsum primis
                in faucibus.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Vendor */}
      {/* Theme Base, Components and Settings */}
    </div>
  );
};

export default App;
